<template>
  <el-form label-position="right" label-width="180px">
    <el-row :gutter="5">
      <el-col :xs="24" :sm="24" :md="12" :lg="16" :xl="16">
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="Forma de pagamento 1" prop="paymentType1">
              <el-radio v-model="paymentType1" :disabled="paymentType2 === '1'" label="1">Dinheiro</el-radio>
              <el-radio v-model="paymentType1" :disabled="paymentType2 === '2'" label="2">Cartão de
                débito</el-radio>
              <el-radio v-model="paymentType1" :disabled="paymentType2 === '3'" label="3">Cartão de
                crédito</el-radio>
              <el-radio v-model="paymentType1" :disabled="paymentType2 === '4'" label="4">PIX</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item label="Valor Recebido" prop="money1">
              <el-input :placeholder="$t('numero')" :controls="false" type="number"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :min="0" style="width: 130px;"
                v-model="money1"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="paymentType1 === '1'">
            <el-form-item label="Troco" prop="changed">
              <el-input :placeholder="$t('numero')" :controls="false" type="number"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :min="0" style="width: 130px;"
                v-model="changed"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item label="Forma de pagamento 2" prop="paymentType2">
              <el-radio v-model="paymentType2" :disabled="paymentType1 === '1'" label="1">Dinheiro</el-radio>
              <el-radio v-model="paymentType2" :disabled="paymentType1 === '2'" label="2">Cartão de
                débito</el-radio>
              <el-radio v-model="paymentType2" :disabled="paymentType1 === '3'" label="3">Cartão de
                crédito</el-radio>
              <el-radio v-model="paymentType2" :disabled="paymentType1 === '4'" label="4">PIX</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="6" :lg="6" :xl="6">
            <el-form-item label="Valor Recebido" prop="money2">
              <el-input :placeholder="$t('numero')" :controls="false" type="number"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :min="0" style="width: 130px;"
                v-model="money2"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-if="paymentType2 === '1'">
            <el-form-item label="Troco" prop="changed">
              <el-input :placeholder="$t('numero')" :controls="false" type="number"
                pattern="^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$" :min="0" style="width: 130px;"
                v-model="changed"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
        <div class="row">
          <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
            <div class="card" style="height: 100px;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-9">
                    <div class="numbers">
                      <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor Recebido</p>
                      <h5 class="font-weight-bolder orange">
                        {{
                          received
                          | currency("R$ ", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                          })
                        }}

                      </h5>
                    </div>
                  </div>
                  <div class="col-3 text-end">
                    <div class="icon icon-shape bg-gradient-success shadow-primary text-center rounded-circle">
                      <i class="ni ni-money-coins text-lg opacity-10" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
            <div class="card" style="height: 100px;">
              <div class="card-body p-3">
                <div class="row">
                  <div class="col-9">
                    <div class="numbers" v-if="missing > 0">
                      <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor Faltante</p>
                      <h5 class="font-weight-bolder red">
                        {{
                          missing
                          | currency("R$ ", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                          })
                        }}

                      </h5>
                    </div>
                    <div class="numbers" v-else>
                      <p class="text-sm mb-0 text-uppercase font-weight-bold">Valor Sobrando</p>
                      <h5 class="font-weight-bolder green">
                        {{
                          missing
                          | currency("R$ ", 2, {
                            thousandsSeparator: ".",
                            decimalSeparator: ",",
                          })
                        }}

                      </h5>
                    </div>
                  </div>
                  <div class="col-3 text-end">
                    <div class="icon icon-shape bg-gradient-default shadow-primary text-center rounded-circle">
                      <i class="fa fa-money text-lg opacity-10" style="color: white" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  name: "PdvClosedValues",
  props: ["pay", "licence"],
  data() {
    return {
      paymentType1: '1',
      paymentType2: '2',
      type: "0",
      money1: 0,
      money2: 0,
      changed: 0,
    }
  },
  computed: {
    received() {
      const vm = this;
      return +vm.money1 + +vm.money2 - +vm.changed;
    },
    missing() {
      const vm = this;
      return +vm.pay - vm.received;
    },
  },
  methods: {
    paymentData() {
      const vm = this;
      return [{
        paymentType: vm.paymentType1,
        money: vm.money1,
        changed: vm.paymentType1 === '1' ? vm.changed : 0,
      }, {
        paymentType: vm.paymentType2,
        money: vm.money2,
        changed: vm.paymentType2 === '1' ? vm.changed : 0,
      }]
    },
    clear() {
      this.paymentType = '2';
      this.type = '0';
      this.money = 0;
    },
  }
}
</script>

<style>
.red {
  color: red;
}

.green {
  color: #67C23A;
}
</style>